import React, { useEffect, useRef, useState, useCallback } from 'react';
import { number, string, node, oneOf, bool } from 'prop-types';

import * as S from './styles';

const Tooltip = props => {
  const {
    children,
    className,
    title,
    placement,
    width,
    align,
    wrapperWidth,
    renderOnMouseOver,
    forcedVisible,
  } = props;

  const [parentWidth, setParentWidth] = useState(null);
  const [isHovering, setHoverState] = useState(false);

  const containerRef = useRef(null);

  useEffect(() => {
    if (!window || !containerRef.current) {
      return;
    }

    setParentWidth(containerRef.current.getBoundingClientRect().width);
  }, []);

  const handleMouseHover = useCallback(() => {
    if (!renderOnMouseOver) return null;
    return setHoverState(!isHovering);
  }, [isHovering, renderOnMouseOver]);

  return (
    <S.TooltipWrapper
      ref={containerRef}
      className={className}
      style={{ width: wrapperWidth }}
      onMouseEnter={handleMouseHover}
      onMouseLeave={handleMouseHover}
      renderOnMouseOver={renderOnMouseOver}
      isHovering={isHovering || forcedVisible}
    >
      {(forcedVisible || !renderOnMouseOver || isHovering) && title && (
        <S.Tooltip
          placement={placement}
          width={width}
          align={align}
          parentWidth={parentWidth}
          data-test="Tooltip"
          role="tooltip"
        >
          {title}
        </S.Tooltip>
      )}
      {children}
    </S.TooltipWrapper>
  );
};

Tooltip.propTypes = {
  children: node.isRequired,
  className: string,
  title: string,
  placement: oneOf(['top', 'bottom', 'left', 'right']),
  align: oneOf(['left', 'right', 'center']),
  width: number,
  wrapperWidth: number,
  renderOnMouseOver: bool,
  forcedVisible: bool,
};

Tooltip.defaultProps = {
  className: undefined,
  title: undefined,
  placement: 'bottom',
  align: 'center',
  width: undefined,
  wrapperWidth: undefined,
  renderOnMouseOver: false,
  forcedVisible: false,
};

export default Tooltip;
